<div class="ceil-title">
  <a [group]="group">{{ group.name }}</a>
</div>
<div class="ceil-description">{{group.description | textTruncate: 190}}</div>
<div class="ceil-user-info-wrapper d-flex justify-content-between align-items-center">
  <div class="ceil-user-info d-flex align-items-center">
    <div class="ceil-logo">
      <a [group]="group">
        <app-avatar [src]="group.icon" [placeholder]="group | initials" class="small right"></app-avatar>
      </a>
    </div>
    <div class="d-flex align-items-center">
      <p class="ceil-description">Age Group: {{group.agegroup.name | clearAgeGroup}} • {{group.members}} members</p>
    </div>
  </div>
  <div class="ceil-explore-link">
    <a href="" (click)="subscribeToGroup(); false" *ngIf="!group.is_subscriber && !group.is_requested">Join group</a>
    <a
      href=""
      (click)="unsubscribeFromGroup(group); false"
      *ngIf="!group.is_autor && (group.is_subscriber ||group.is_requested)"
      >Unsubscribe</a
    >
  </div>
</div>
